/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Col,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import ComponentCard from '../../../components/ComponentCard';
import api from '../../../constants/api';
import { toast } from 'react-toastify';
import AppButton from '../../../components/common/AppButton';
import ActionButton from '../../../components/common/ActionButton';
import Text from '../../../components/common/Text';
import DataTable from '../../../components/common/DataTable';
import BreadCrumbs from '../../../layouts/breadcrumbs/BreadCrumbs';
import BackButton from '../../../components/common/BackButton';
import { showSwal } from '../../../constants/swalConfig';
import { isApiSuccess } from '../../../constants/apiResult';
import { isStaff } from '../../../constants/tenancy';

export default function Brands() {
  // Staff can view but not add, edit or delete.
  const readOnly = isStaff();
  const [data, setData] = useState({
    name: '',
    type: '',
    operation: 'insert',
    id: null, // For updating
  });
  const [oilBrands, setOilBrands] = useState([]);
  const [batteryBrands, setBatteryBrands] = useState([]);
  const [tyreBrands, setTyreBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  const rowsPerPage = 15;
  const [oilPage, setOilPage] = useState(1);
  const [batteryPage, setBatteryPage] = useState(1);
  const [tyrePage, setTyrePage] = useState(1);
  const oilTotalPages = Math.ceil(oilBrands.length / rowsPerPage);
  const batteryTotalPages = Math.ceil(batteryBrands.length / rowsPerPage);
  const tyreTotalPages = Math.ceil(tyreBrands.length / rowsPerPage);
  const visibleOilBrands = oilBrands.slice((oilPage - 1) * rowsPerPage, oilPage * rowsPerPage);
  const visibleBatteryBrands = batteryBrands.slice(
    (batteryPage - 1) * rowsPerPage,
    batteryPage * rowsPerPage
  );
  const visibleTyreBrands = tyreBrands.slice((tyrePage - 1) * rowsPerPage, tyrePage * rowsPerPage);

  const [activeTab, setActiveTab] = useState('1');

  const handleInputs = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const getAllBrandsForOil = (obj) => {
    if (obj.type === '0') {
      setLoading(true);
    }
    api
      .get('/store/getAssignedOilBrands', { params: { type: obj.type } })
      .then((res) => {
        if (obj.type === '0') {
          setOilBrands(res.data.data);
          getAllBrandsForOil({ operation: 'fetch', type: '1' });
        } else if (obj.type == '1') {
          setBatteryBrands(res.data.data);
          getAllBrandsForOil({ operation: 'fetch', type: '2' });
        } else {
          setTyreBrands(res.data.data);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const addUpdateOilAndBatteryBrand = () => {
    const { id: brandId, ...brandPayload } = data || {};
    if (data.operation !== 'insert' && !brandId) {
      toast.error('Please select a brand to edit');
      return;
    }
    const request =
      data.operation === 'insert'
        ? api.post('/store/addOilAndBatteryBrand', brandPayload)
        : api.put(`/store/updateOilAndBatteryBrand/${brandId}`, brandPayload);
    request.then((res) => {
      if (data.operation === 'insert') {
        toast.success('Brand added successfully');
      } else {
        toast.success('Brand updated successfully');
      }
      // Refresh the brand lists after adding/updating
      getAllBrandsForOil({ operation: 'fetch', type: '0' });
      setData({ name: '', type: '', operation: 'insert', id: null });
    });
  };

  const editBrand = (brand) => {
    setData({
      name: brand.ob_name,
      type: brand.type,
      operation: 'update',
      id: brand.ob_id,
    });
  };

  useEffect(() => {
    getAllBrandsForOil({ operation: 'fetch', type: '0' });
  }, []);

  useEffect(() => {
    if (oilTotalPages > 0 && oilPage > oilTotalPages) {
      setOilPage(oilTotalPages);
    }
  }, [oilPage, oilTotalPages]);

  useEffect(() => {
    if (batteryTotalPages > 0 && batteryPage > batteryTotalPages) {
      setBatteryPage(batteryTotalPages);
    }
  }, [batteryPage, batteryTotalPages]);

  useEffect(() => {
    if (tyreTotalPages > 0 && tyrePage > tyreTotalPages) {
      setTyrePage(tyreTotalPages);
    }
  }, [tyrePage, tyreTotalPages]);

  const deleteCar = (id) => {
   showSwal({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
}, 'delete').then((result) => {
  if (result.isConfirmed) {
        api
          .post('/store/addUpdateOilAndBatteryBrand', { operation: 'delete', id })
          .then((res) => {
            if (isApiSuccess(res)) {
              window.location.reload();
            }
          })
          .catch(() => {
            showSwal({
              title: 'Error',
              text: 'Cannot Delete Record',
              icon: 'error',
            });
          });
      }
    });
  };
  return (
    <div>
      <BreadCrumbs leadingContent={<BackButton />} />
      <ComponentCard>
        {!readOnly && (
        <Row className="brands-filter-row g-2">
          <Col lg={3}>
            <FormGroup>
              <Label htmlFor="name-input">Name</Label>
              <Input
                onChange={handleInputs}
                value={data.name}
                className="form-control"
                type="text"
                name="name"
                id="name-input"
              />
            </FormGroup>
          </Col>
          <Col lg={3}>
            <FormGroup>
              <Label htmlFor="type-input">Type</Label>
              <select
                className="form-control"
                name="type"
                value={data.type}
                onChange={handleInputs}
                id="type-input"
              >
                <option value="">-- Select --</option>
                <option value="0">Oil</option>
                <option value="1">Battery</option>
                <option value="2">Tyre</option>
              </select>
            </FormGroup>
          </Col>
          <Col lg="auto" className="d-flex align-items-end brands-add-action">
            <AppButton
              label={data.operation === 'insert' ? 'Add Brand' : 'Update Brand'}
              variant="buttonColor"
              onClick={addUpdateOilAndBatteryBrand}
            />
          </Col>
        </Row>
        )}
        <Row>
          <Nav pills className="custom-pills mt-4">
            <NavItem>
              <NavLink
                className={activeTab === '1' ? 'active text-dark-white' : 'cursor-pointer'}
                onClick={() => {
                  setActiveTab('1');
                }}
              >
                Oil
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === '2' ? 'active text-dark-white' : 'cursor-pointer'}
                onClick={() => {
                  setActiveTab('2');
                }}
              >
                Batteries
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === '3' ? 'active text-dark-white' : 'cursor-pointer'}
                onClick={() => {
                  setActiveTab('3');
                }}
              >
                Tyres
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="mt-3">
            <TabPane tabId="1">
              <DataTable
                columns={[
                  { key: 'number', header: 'S.no', render: (row, index) => index + 1 },
                  { key: 'name', header: 'Name', render: (row) => row.ob_name },
                  ...(readOnly ? [] : [{ key: 'action', header: 'Action', render: (row) => (
                    <div className="d-flex gap-2">
                      <ActionButton action="edit" onClick={() => editBrand(row)} />
                      <ActionButton action="delete" onClick={() => deleteCar(row.ob_id)} />
                    </div>
                  ) }]),
                ]}
                data={oilBrands}
                loading={loading}
                searchable={false}
                pageSize={rowsPerPage}
                emptyMessage="No oil brands found"
                rowKey={(row) => row.ob_id}
              />
            </TabPane>
            <TabPane tabId="2">
              <DataTable
                columns={[
                  { key: 'number', header: 'S.no', render: (row, index) => index + 1 },
                  { key: 'name', header: 'Name', render: (row) => row.ob_name },
                  ...(readOnly ? [] : [{ key: 'action', header: 'Action', render: (row) => (
                    <div className="d-flex gap-2">
                      <ActionButton action="edit" onClick={() => editBrand(row)} />
                      <ActionButton action="delete" onClick={() => deleteCar(row.ob_id)} />
                    </div>
                  ) }]),
                ]}
                data={batteryBrands}
                loading={loading}
                searchable={false}
                pageSize={rowsPerPage}
                emptyMessage="No battery brands found"
                rowKey={(row) => row.ob_id}
              />
            </TabPane>
            <TabPane tabId="3">
              <DataTable
                columns={[
                  { key: 'number', header: 'S.no', render: (row, index) => index + 1 },
                  { key: 'name', header: 'Name', render: (row) => row.ob_name },
                  ...(readOnly ? [] : [{ key: 'action', header: 'Action', render: (row) => (
                    <div className="d-flex gap-2">
                      <ActionButton action="edit" onClick={() => editBrand(row)} />
                      <ActionButton action="delete" onClick={() => deleteCar(row.ob_id)} />
                    </div>
                  ) }]),
                ]}
                data={tyreBrands}
                loading={loading}
                searchable={false}
                pageSize={rowsPerPage}
                emptyMessage="No tyre brands found"
                rowKey={(row) => row.ob_id}
              />
            </TabPane>
          </TabContent>
        </Row>
      </ComponentCard>
    </div>
  );
}
